import { css } from '@microsoft/fast-element';
import { genericFormStyling } from '../../../../../styles/common/form.styles';
import { mixinRobotoMedium } from '../../../../../styles';

export const assignedUsersStyles = css`
  ${genericFormStyling}

  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
  }

  .header {
    font-size: 16px;
    color: var(--primary-color);
    font-weight: 500;
    ${mixinRobotoMedium()}
  }

  .button-container {
    display: flex;
    gap: 10px;
  }

  .button-container zero-button {
    height: 37px;
  }

  .wrapper {
    height: 100%;
  }

  zero-grid-pro {
    max-height: calc(100% - 55px);
    display: block;
  }

  zero-grid-pro::part(rightButtons) {
    padding: 2px 0px;
    display: flex;
    justify-content: flex-end;
    gap: 4px;
  }

  zero-grid-pro::part(gridIconButton) {
    background-color: rgba(255, 255, 255, 0.05);
    margin: 0px;
    width: 37px;
    height: 25px;
  }

  zero-grid-pro::part(iconWrapper) {
    display: flex;
    align-items: center;
  }

  zero-button svg {
    width: 20px;
    height: 16px;
  }
`;
